export default __webpack_public_path__ + "static/media/36I-102810_-44088_0.e83072ec.jpg";